<template>
    <div class="box">
        <div class="box-content">

            <template v-if="!loading && total_count > 0">
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div class="content-uploads-list-view" v-show="notifications.length > 0">
                
                <table class="table _lined">
                    <tbody>
                    <template v-for="notification in notifications">
                        <tr :key="'notification_' + notification.id">
                            <td class="content-uploads-list-view-image">
                                <div>
                                    <img :src="`${$aws_bucket_url}${notification.content_upload.thumbnail_url}`" @error="imageFallbackIcon">
                                </div>
                            </td>
                            <td class="content-uploads-list-view-name">
                                {{ notification.content_upload.name }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Company Type</th>
                                        <th>User Email</th>
                                        <th>User Name</th>
                                    </tr>
                                    </thead>
                                    <tr v-for="(notification_for_user, index) in notification.content_upload_digest_notifications_for_users" :key="'user_' + index">
                                        <td>
                                            {{ notification_for_user.user.company.name }}
                                        </td>
                                        <td v-if="notification_for_user.user.company_id === 1">
                                            {{ notification_for_user.user.user_type.label }}
                                        </td>
                                        <td v-else>
                                            {{ notification_for_user.user.company.company_type.label }}
                                        </td>
                                        <td>
                                            {{ notification_for_user.user.email }}
                                        </td>
                                        <td>
                                            {{ notification_for_user.user.name }}
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>

            <template v-if="!loading && total_count === 0">
                <strong class="block mt-3 p-3">
                    No Notifications To Show
                </strong>
            </template>

            <template v-if="!loading && total_count > 0">
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            notifications: [],
            loading: true,
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            limit: 1,
        };
    },
    mounted() {
        this.loadNotifications();
    },
    methods: {
        loadNotifications() {
            axios.post('/downloads/get-notification-preview-list', {
                page_number: this.current_page,
                limit: this.limit,
            }).then((response) => {
                this.notifications = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
                this.loading = false;
            });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadNotifications();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadNotifications();
        },
        imageFallbackIcon(event) {
            event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
        },
    },
};
</script>
